module.exports = __webpack_public_path__ + "static/media/workAntihumidity8.a6ef8073.jpg";